import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import moment from 'moment';
import * as c from '../constant';
import * as actions from '../actions';

function UpdateOrDate({ id, data, updatingOrDate, updateOrDate, getItem }) {
  const [formData, setFormData] = useState({
    paid_date: '',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    updateOrDate(id, formData, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeDate = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.target.value : '',
    });
  };

  const applicationDate =
    moment(_.get(data, 'attributes.processing_at')).format('MM/DD/YYYY') || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Select Paid Date
            </label>
            <DateInputPicker
              className="form-control"
              minDate={new Date(applicationDate)}
              maxDate={new Date()}
              onChange={handleOnChangeDate('paid_date')}
              value={_.get(formData, 'paid_date') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            disabled={updatingOrDate}
          >
            <span className="font-weight-bold">
              {/* eslint-disable */}
              {updatingOrDate ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateOrDate.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  updateOrDate: PropTypes.instanceOf(Function).isRequired,
  updatingOrDate: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updatingOrDate: api.loading.indexOf(c.UPDATE_OR_DATE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateOrDate);
